import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerPages = () => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['customer', customerId, 'pages'],
    queryFn: () => get(`/management/customers/${customerId}/pages`),
  })
}
